<template>
    <rkm-overlay>
        <rkm-layout-body
            v-if="!isSetorAcsTacs"
            :title="title"
        >
            <rkm-alert color="warning">
                É necessário estar logado com um setor do tipo <strong>ACS/TACS</strong> para poder utilizar a funcionalidade.
            </rkm-alert>
        </rkm-layout-body>

        <rkm-layout-body
            v-else-if="!isOcupacaoAcsTacs"
            :title="title"
        >
            <rkm-alert color="warning">
                É necessário estar logado com o CBO <strong>515105 - Agente Comunitário de Saúde</strong> ou
                <strong>322255 - Técnico em Agente Comunitário de Saúde</strong> para poder utilizar a funcionalidade.
            </rkm-alert>
        </rkm-layout-body>

        <rkm-layout-body
            v-else
            :title="title"
        >
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/acolhimento-acs-tacs/List'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'
import ocupacao from '@/enums/sigtap/ocupacao'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { List },
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            lotacao: 'getLotacao',
        }),
        isSetorAcsTacs() {
            return [this.enums.setorTipo.ACS_TACS].includes(this.centroCusto.setor.tipoId)
        },
        isOcupacaoAcsTacs() {
            return [
                this.enums.ocupacao.TECNICO_EM_AGENTE_COMUNITARIO_DE_SAUDE,
                this.enums.ocupacao.AGENTE_COMUNITARIO_DE_SAUDE
            ].includes(this.lotacao.ocupacao.codigo)
        },
    },
    data: () => ({
        title: 'Acolhimento ACS/TACS',
        enums: { setorTipo, ocupacao },
    }),
}
</script>